import { render, staticRenderFns } from "./RunnitPlanTokensUsageMenuOrBottomSheet.vue?vue&type=template&id=4797d819&scoped=true"
import script from "./RunnitPlanTokensUsageMenuOrBottomSheet.vue?vue&type=script&lang=ts"
export * from "./RunnitPlanTokensUsageMenuOrBottomSheet.vue?vue&type=script&lang=ts"
import style0 from "./RunnitPlanTokensUsageMenuOrBottomSheet.vue?vue&type=style&index=0&id=4797d819&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4797d819",
  null
  
)

export default component.exports